import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { InnerhivePage } from '../InnerhivePage';
import { IonButton, IonButtons, IonToolbar } from '@ionic/react';
import { Text } from '../components/Text';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { ManageButton } from './ManageButton';
import { AddPostButton } from './AddPostButton';
import { TemplateProvider } from '../notes/generic-notes/note-templates/TemplateProvider';
import { NoteTemplateMenu } from '../notes/generic-notes/note-templates/NoteTemplateMenu';
import { CommunityTabsProvider } from './CommunityTabsProvider';
import { AddCareMapButton } from '../caremap/AddCareMapButton';
import { CreateAccountButton } from '../auth/CreateAccountButton';
import { AppPrincipal, isAnonymousViewer } from '../auth/AppPrincipal';
import { CareMapState } from '../caremap/CareMapState';
import { Redirect } from 'react-router';

const useStyles = createUseStyles(() => ({
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },

    image: {
        maxWidth: 500,
        margin: 'auto',
        padding: '30px 60px 0 20px'
    }
}));

export const CommunityNoCareMapPage: FC = () => {
    const classes = useStyles();

    const tabsProvider = useInstance(CommunityTabsProvider);

    const templates = useInstance(TemplateProvider).getTemplates({section: 'patient'});
    const groceriesTemplate = templates.find(t => t.templateId === 'groceries');
    const rideTemplate = templates.find(t => t.templateId === 'ride');

    const isAnonymous = isAnonymousViewer(useInstance(AppPrincipal));

    // if user logs out, they become anon and land on this page, then if they log back in to their
    // existing account with a care map, they end up back on this page, and we need to redirect
    const careMapState = useInstance(CareMapState);
    if (careMapState.getMostRecentCaremap() && !careMapState.getIncompleteCareMap()) {
        return <Redirect to={`/community/${careMapState.getMostRecentCaremap()!.careMapId}/feed`} />;
    }

    return (
        <InnerhivePage
            data-id="community-empty-page"
            title="Community"
            tabs={tabsProvider.getTabs()}
            skipRequireName
        >
            <div style={{padding: '10px 20px 5px'}}>
                {isAnonymous && <CreateAccountButton trackingFrom="Community" />}
                {!isAnonymous && <AddCareMapButton />}
            </div>

            {/* cover everything to prevent clicking and make it look disabled */}
            <div style={{width: '100%', height: '100%', zIndex: 9999, pointerEvents: 'none'}}>
                <div style={{width: '100%', zIndex: 9999, opacity: 0.5, pointerEvents: 'none'}}>
                    <IonToolbar>
                        <div className={classes.toolbar}>
                            &nbsp;<IonButtons slot="end"><ManageButton careMapId="" /></IonButtons>
                        </div>
                    </IonToolbar>
                    <AddPostButton onClick={() => {}} />
                    <div style={{display: 'flex'}}>
                        <IonButton fill="outline">{groceriesTemplate?.label}</IonButton>
                        <IonButton fill="outline">{rideTemplate?.label}</IonButton>
                    </div>
                    <NoteTemplateMenu hasButtons onItemClick={() => {}} templates={[]} />
                </div>
                <p>
                    <Text>
                        Welcome your community to Innerhive with an intro post! Here’s an example:
                    </Text>
                </p>
                <p>
                    <Text type="detail">
                        <i style={{fontSize: 14}}>
                        Hi everyone! I want to update you on Grandpa Joe—he’s been diagnosed with dementia, and I’ll be helping with his daily care. With many appointments and a large care team, I’ll use Innerhive to stay organized and keep you informed. Your support means a lot, even if I can’t always reply.
                        </i>
                    </Text>
                </p>
                <div className={classes.image}>
                    <img src="/assets/images/share/spread-love.png" alt="" />
                </div>

            </div>
        </InnerhivePage>
    );
};
